import { Inject, Injectable } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { AppDataService } from "@app/services/appData.service";
import { Router } from "@angular/router";
import { isEqual } from 'lodash'

const  DEBUG = false;

export interface PushPopItem {
    section: string,
    defaultRoute: string,
    name: string,
    iconClass: string,
    iconClassSelected: string,
    tid: string
    hidden?: boolean,
    hideLabel?: boolean,
    hideIcon?: boolean,
    isDropdownWhenWebFull?: boolean,
    history?: [],
}

@Injectable({ providedIn: "root" })
export class PushPopService {

    items: PushPopItem[] = [];
    bodyElement: HTMLBodyElement;
    currentSection: string;

    constructor(
        @Inject(AppDataService) private appDataService: AppDataService,
        @Inject(DOCUMENT) private $document: Document,
        @Inject(Router) private router: Router) {

        this.init(this.appDataService.pushPopItems);
        this.bodyElement = this.$document.querySelector('body')
    }

    init(initItems: PushPopItem[]) {
        initItems.forEach((initItem) => {
            this.createNewItem(initItem);
        })
        this.items = initItems;
    }

    getFooterItems() {
        let footerItems: PushPopItem[] = [];
        this.items.forEach((item) => {
            // if the hidden property isn't found, then add to footer bar.
            if(!item.hidden) {
                footerItems.push(item);
            }
        });
        return footerItems;
    }

    navBack(){
        //get current section's history list
        if(DEBUG) console.log(this.currentSection);
        const tab: PushPopItem = this.mapTab(this.currentSection);
        if(tab.history && tab.history.length > 1){
            // tell app that nav transition should move backwards
            this.bodyElement.classList.remove('stateTransitionForward');
            this.bodyElement.classList.add('stateTransitionBackward');

            if(DEBUG) console.log("Before", tab.history);
            //pop off the current value and throw it away
            tab.history.pop();
            //pop off the next value and nav to it.
            const pageToNavTo = tab.history.pop();
            if(DEBUG) console.log(pageToNavTo);
            if(DEBUG) console.log("After", tab.history);
            this.updateTabHistory(tab);
            // Update when we have routing working
            this.router.navigateByUrl(pageToNavTo['url'], { state: pageToNavTo['params'] });
        }
    }

    getSection(){
        if(!this.currentSection){
            this.setSection(this.items[0].section)
        }
        return this.currentSection;
    }

    setSection(section){
        this.currentSection = section;
    }

    createNewItem(item){
        if(!item.defaultRoute){
            throw new Error("Default route required")
        }
        if(!item.name){
            throw new Error("Name required")
        }
        if(!item.section){
            throw new Error("Section required")
        }

        if(!item.history){
            item.history = [];
        }
        this.items.push(item);
    }

    updateOnStateChange(fromStateName: string, fromParams: any, toUrl: string, toStateName: string, toParams: any): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            // update current section to the correct section
            if(toStateName.split('.')[1] && !toParams.comingFromPayNow){
                if(DEBUG) console.log(toStateName);
                this.currentSection = this.getSectionName(toStateName);
                if(DEBUG) console.log(this.currentSection);

                //pageHistory = currentSections history array;
                const tab: PushPopItem = this.mapTab(this.currentSection);
                if(DEBUG) console.log(tab);
                let pageHistory = [];
                pageHistory = JSON.parse(JSON.stringify(tab.history));
                //reset pageHistory if navigating backing to default page
                if(toUrl === tab.defaultRoute){
                    pageHistory = [];
                }
                let state = { url: toUrl, name:toStateName, params: toParams };

                // if more than one element and toState.name = second to last entry then remove last entry
                if(pageHistory.length > 1 && isEqual(state, pageHistory[pageHistory.length-2])){
                    pageHistory.pop();
                }

                // if toState.name != fromState.name, and it's not the last item in page history then add to list
                if(toStateName !== fromStateName && !isEqual(state, pageHistory[pageHistory.length - 1])){
                    pageHistory.push(state);
                }

                //update tab history
                tab.history = JSON.parse(JSON.stringify(pageHistory));
                if(tab.history.length > 1){
                    if(!this.bodyElement.classList.contains("stateShowBack")){
                        this.bodyElement.classList.add("stateShowBack");
                        if(DEBUG) console.log('add class');
                    }
                    if(DEBUG) console.log('tab history greater than 1');
                }else{
                    if(this.bodyElement.classList.contains("stateShowBack")) {
                        this.bodyElement.classList.remove("stateShowBack");
                        if(DEBUG) console.log('remove class');
                    }
                    if(DEBUG) console.log('tab history less than 1')
                }
                if(DEBUG) console.log(tab);
                this.updateTabHistory(tab);

                // if neither forward nor backward transition is defined
                if(!this.bodyElement.classList.contains('stateTransitionBackward') &&
                    !this.bodyElement.classList.contains('stateTransitionForward')) {
                    // set default (note: should only be the case with first time view)
                    this.bodyElement.classList.contains('stateTransitionForward');
                }

                resolve();
            }else{
                reject();
            }
        })
    }

    getItems(){
        return this.items;
    }

    setItems(newItems){
        this.items = newItems
    }

    arrayObjectIndexOf(myArray, searchTerm, property) {
        for(let i = 0; i < myArray.length; i++) {
            if (myArray[i][property] === searchTerm) return i;
        }
        return -1;
    }

    //find the history array for the section that we are navigating too
    mapTab(section): PushPopItem{
        if(DEBUG) console.log(this.items);
        if(DEBUG) console.log(section);
        const tabIndex = this.arrayObjectIndexOf(this.items, section, "section");
        if(DEBUG) console.log(tabIndex);
        return JSON.parse(JSON.stringify(this.items[tabIndex]));
    }

    navToTab(section): Promise<void>{
        return new Promise<void>((resolve) => {
            if(DEBUG) console.log(section);
            if(DEBUG) console.log(this.mapTab(section));
            const tab = this.mapTab(section);
            if(DEBUG) console.log(tab);
            const currentState = this.getStateName(this.router.url);
            if(DEBUG) console.log(currentState);
            if(this.currentSection === section){
                //pressed tab button and already in same section
                //so lets go to the default state and clear
                //the history
                this.router.navigateByUrl(tab.defaultRoute);
                tab.history = [];
            }else{
                //if the last history page doesn't match the current state then we can go to the new state

                if(tab.history.length > 0 && tab.history[tab.history.length-1]['name'] !== currentState) {
                    if(DEBUG) console.log(tab.history);
                    this.router.navigateByUrl(tab.history[tab.history.length - 1]['url'], { state: tab.history[tab.history.length - 1]['params'] })
                } else if(currentState === tab.defaultRoute){
                    //don't perform the navigation if we are already at the defaultRoute
                } else { //no history so just go to the defaultRoute
                    this.router.navigateByUrl(tab.defaultRoute);
                    // tab.history.push(tab.defaultRoute);
                }
            }

            this.updateTabHistory(tab);
            resolve();
        })
    }

    updateTabHistory(tab){
        if(DEBUG) console.log(tab);
        const tabIndex = this.arrayObjectIndexOf(this.items, tab.section, "section");
        if(DEBUG) console.log(this.items);
        if(DEBUG) console.log(tabIndex);
        this.items[tabIndex] = JSON.parse(JSON.stringify(tab));
        if(DEBUG) console.log(this.items[tabIndex]);
    }

    getSectionName(stateName){
        const name = stateName.split('.')[0];
        if(DEBUG) console.log(name);
        return name;
    }

    getStateName(url: string): string {

        const tabIndex = this.arrayObjectIndexOf(this.items, url, "defaultRoute");
        if(tabIndex >= 0) {
            return JSON.parse(JSON.stringify(this.items[tabIndex])).name;
        } else {
            return "";
        }
    }

}

